import universal from 'react-universal-component';
import ErrorLoadingRouteChunk from '@client/containers/errorLoadingRouteChunk/ErrorLoadingRouteChunk';
import Loader from '@client/components/loader/Loader';
import { getMainRoutes } from '@client/shared/utils/routerUtils/routerUtils';
import { withRestrictions } from '@client/helperComponents/restrict/withRestrictions';

const options = {
  error: ErrorLoadingRouteChunk,
  loading: Loader,
};

const ROUTES = getMainRoutes();

export const inspirationPageRoutes = {
  path: `${ROUTES.INSPIRATION.TO}`,
  exact: false,
  componentPath: 'pages/inspirationPage/InspirationPage',
  Component: withRestrictions({
    shouldBeLoggedIn: true,
  })(
    universal(import('pages/inspirationPage/InspirationPage'), options),
    universal(import('pages/loginPage/LoginPage'), options)
  ),
  routes: [
    {
      path: `${ROUTES.INSPIRATION.TO}`,
      exact: true,
      componentPath:
        'pages/inspirationPage/activeInspirationRoute/ActiveInspirationRoute',
      Component: universal(
        import(
          'pages/inspirationPage/activeInspirationRoute/ActiveInspirationRoute'
        ),
        options
      ),
    },
    {
      path: `${ROUTES.INSPIRATION.ROUTES.ACTIVE.TO}`,
      exact: true,
      componentPath:
        'pages/inspirationPage/activeInspirationRoute/ActiveInspirationRoute',
      Component: universal(
        import(
          'pages/inspirationPage/activeInspirationRoute/ActiveInspirationRoute'
        ),
        options
      ),
    },
    {
      path: `${ROUTES.INSPIRATION.ROUTES.INACTIVE.TO}`,
      exact: true,
      componentPath:
        'pages/inspirationPage/inactiveInspirationRoute/InactiveInspirationRoute',
      Component: universal(
        import(
          'pages/inspirationPage/inactiveInspirationRoute/InactiveInspirationRoute'
        ),
        options
      ),
    },
    {
      path: `${ROUTES.INSPIRATION.ROUTES.DRAFT.TO}`,
      exact: true,
      componentPath:
        'pages/inspirationPage/draftInspirationRoute/DraftInspirationRoute',
      Component: universal(
        import(
          'pages/inspirationPage/draftInspirationRoute/DraftInspirationRoute'
        ),
        options
      ),
    },
  ],
};
